/**
 * 从中文语音/文本中解析提醒时间
 * 支持：5分钟后、2小时后、今天下午3点、明天早上9点、3点半 等
 */

function parseClockPart(text) {
  const t = text.replace(/\s/g, "");

  let period = 0; // 0=默认 12=下午 +12 18=晚上 +12(若<12)
  if (/上午|早上|清晨|凌晨/.test(t)) period = 1;
  else if (/中午/.test(t)) period = 2;
  else if (/下午|午后/.test(t)) period = 3;
  else if (/晚上|傍晚|夜间|今晚/.test(t)) period = 4;

  const colon = t.match(/(\d{1,2})[:：](\d{1,2})/);
  if (colon) {
    let h = parseInt(colon[1], 10);
    const min = parseInt(colon[2], 10);
    h = applyPeriod(h, period);
    return { hour: h, minute: min };
  }

  const half = t.match(/(\d{1,2})点(?:半|30分?)/);
  if (half) {
    let h = parseInt(half[1], 10);
    h = applyPeriod(h, period);
    return { hour: h, minute: 30 };
  }

  const dot = t.match(/(\d{1,2})点(?:(\d{1,2})分?)?/);
  if (dot) {
    let h = parseInt(dot[1], 10);
    const min = dot[2] ? parseInt(dot[2], 10) : 0;
    h = applyPeriod(h, period);
    return { hour: h, minute: min };
  }

  return null;
}

function applyPeriod(hour, period) {
  if (period === 2) return hour === 12 ? 12 : hour; // 中午12点
  if (period === 3 && hour >= 1 && hour <= 11) return hour + 12;
  if (period === 4 && hour >= 1 && hour <= 11) return hour + 12;
  return hour;
}

function dayOffset(text) {
  if (/大后天/.test(text)) return 3;
  if (/后天/.test(text)) return 2;
  if (/明天|明早|明日/.test(text)) return 1;
  if (/今天|今日|今晚|今早|今天下午|今天上午|今天晚上/.test(text)) return 0;
  return null;
}

export function parseReminderTime(text, now = new Date()) {
  if (!text || !text.trim()) return null;

  const raw = text.trim();

  const secLater = raw.match(/(\d+)\s*秒(?:以|之)?后/);
  if (secLater) {
    const d = new Date(now.getTime());
    d.setMilliseconds(0);
    d.setSeconds(d.getSeconds() + parseInt(secLater[1], 10));
    return d;
  }

  if (/一分钟(?:以|之)?后|1分钟(?:以|之)?后/.test(raw)) {
    const d = new Date(now.getTime());
    d.setMilliseconds(0);
    d.setSeconds(d.getSeconds() + 60);
    return d;
  }

  const minLater = raw.match(/(\d+)\s*分(?:钟)?(?:以|之)?后/);
  if (minLater) {
    const d = new Date(now.getTime());
    d.setSeconds(0, 0);
    d.setMinutes(d.getMinutes() + parseInt(minLater[1], 10));
    return d;
  }

  const hourLater = raw.match(/(\d+)\s*小(?:时)?(?:以|之)?后/);
  if (hourLater) {
    const d = new Date(now.getTime());
    d.setSeconds(0, 0);
    d.setHours(d.getHours() + parseInt(hourLater[1], 10));
    return d;
  }

  const clock = parseClockPart(raw);
  const offset = dayOffset(raw);

  if (clock) {
    const d = new Date(now.getTime());
    d.setSeconds(0, 0);
    const addDays = offset !== null ? offset : 0;
    d.setDate(d.getDate() + addDays);
    d.setHours(clock.hour, clock.minute, 0, 0);
    if (d.getTime() <= now.getTime() && offset === null) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  if (offset !== null && offset >= 0) {
    const d = new Date(now.getTime());
    d.setSeconds(0, 0);
    d.setDate(d.getDate() + offset);
    d.setHours(9, 0, 0, 0);
    return d;
  }

  return null;
}

export function extractReminderContent(text) {
  if (!text) return "";
  return text
    .replace(/(\d+)\s*秒(?:以|之)?后/g, "")
    .replace(/一分钟(?:以|之)?后|1分钟(?:以|之)?后/g, "")
    .replace(/(\d+)\s*分(?:钟)?(?:以|之)?后/g, "")
    .replace(/(\d+)\s*小(?:时)?(?:以|之)?后/g, "")
    .replace(/今天|今日|明天|明日|后天|大后天|上午|下午|晚上|早上|中午|傍晚/g, "")
    .replace(/\d{1,2}[:：]\d{1,2}/g, "")
    .replace(/\d{1,2}点(?:半|\d{1,2}分?)?/g, "")
    .replace(/提醒我|记得|要|去/g, "")
    .trim() || text.trim();
}

export function formatReminderTime(date) {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  const now = new Date();
  const isToday = d.toDateString() === now.toDateString();
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const isTomorrow = d.toDateString() === tomorrow.toDateString();

  const time = d.toLocaleTimeString("zh-CN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  if (isToday) return `今天 ${time}`;
  if (isTomorrow) return `明天 ${time}`;
  return d.toLocaleString("zh-CN", {
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}
